/**
 * add Microsoft Clarity
 */
(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "m1a2ptcwae");


/**
 * Make social links open in a new window
 */
document.addEventListener("DOMContentLoaded", function(arg) {
  var tmat_social_links = document.querySelectorAll('.footer__list-social a, .utility-bar .list-social a');
  for (var i = 0; i < tmat_social_links.length; i++) {
    tmat_social_links[i].target = "_blank";
  }
});




/**
 * Accordion for FAQ page
 * @seealso https://www.w3schools.com/howto/howto_js_accordion.asp
 */
document.addEventListener("DOMContentLoaded", function(arg) {
  var accordions = document.getElementsByClassName("tmat-accordion");

  for (var i = 0; i < accordions.length; i++) {
    accordions[i].nextElementSibling.style.display="none";
    
    accordions[i].addEventListener("click", function() {
      /* Toggle between adding and removing the "active" class,
      to highlight the button that controls the panel */
      this.classList.toggle("active");

      /* Toggle between hiding and showing the active panel */
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }
});


/**
 * YMM EasySearch - After fitment check on product page 1) send Klaviyo event & 2) redirect to correct product
 */
document.addEventListener('easysearch_loaded', function (){
  let easyFitmentBtn = document.querySelector(".easysearch-fitment-widget .easysearch-btn-holder #easysearch-search");
  if (easyFitmentBtn){
    easyFitmentBtn.addEventListener("click", function(){ 
      (function() {
        let preselect = localStorage.getItem('easysearch-preselect') || '{"value":""}';
        let preselect_value = JSON.parse(preselect).value.replace(/easysearch-preselect-delimiter/gi, '|').replace(/\|$/, '');
        if (preselect_value) {
          klaviyo.push(["track", "Easysearch Selected",{
            "Value": preselect_value
          }]);
        }
      })();
      
      setTimeout(function() {
        let easyFitmentFail = document.querySelector(".easysearch-fitment-widget .easysearch-fitment-holder .easysearch-fitment-fail");
        let easyOtherResultsBtn = document.querySelector(".easysearch-fitment-widget .easysearch-fitment-other-results a");
        if(easyFitmentFail && easyOtherResultsBtn){
          easyOtherResultsBtn.click();
        }
      },1)
    });
  }
}); 


/**
 * YMM EasySearch - Rename fitment button (product page)
 */
document.addEventListener('easysearch_init_native_search_page', function(e){
  if (easysearch && easysearch.fitmentOptions) {
    easysearch.fitmentOptions.otherResultsText = "See what fits your vehicle";
  }
});


/**
 * Send Meta Lead event on Klayivo form submission
 */
window.addEventListener("klaviyoForms", function(e) { 
  if (e.detail.type == 'submit') {
    fbq('track', 'Lead');
  }
});


/**
 * home page video button shows ymm search
 */
document.addEventListener("DOMContentLoaded", function(arg) {
  var links = document.querySelectorAll(".np-video-loop-hero a");

  for (var i = 0; i < links.length; i++) {    
    links[i].addEventListener("click", function(event) {
      event.preventDefault();
      this.style.display = "none";
      var targetElement = document.querySelector(".easysearch-block-container");
      targetElement.style.display = "block";
      targetElement.scrollIntoView({ 
        behavior: "smooth",
        block: "center"
      });
    });
  }
});


/**
 * Update Sales badge to read "Presidents' Day"
 */
/*
document.addEventListener("DOMContentLoaded", function(arg) {
  var badges = document.querySelectorAll('.price__badge-sale, .card__badge .badge');  
  for (var i = 0; i < badges.length; i++) {
    if (badges[i].innerText == 'Sale') badges[i].innerText = 'Early Release Sale';
  }
});
*/

